import Storage from '../Storage.js';

Storage.setConfig("user_groups", {
  config: {
    method: "user_groups/",
    title: "Группы",
    objectName: "Группа",
    adminGroup: true
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    name: {
      default: "",
      type: "text",
      title: "Имя",
      preset: false,
      width: "auto"
    },
    admin: {
      default: false,
      type: "checkbox",
      title: "Администратор",
      preset: false,
      width: "auto"
    },
    fields: {
      default: [],
      type: "multi",
      request: "fields/",
      objectPageKey: "fields",
      title: "Поля",
      preset: false,
      width: false
    },
  }
});



// WEBPACK FOOTER //
// ./src/config/user_groups.js